define('controllers/modules/dashboard/dashboard',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // Contollers
    'src/controller/controller',
    'controllers/modules/calendar/calendar',
    'controllers/modules/dashboard/dashboard-goal'
    // views
], function(
    // Libs
    _, Backbone, Mustache, U,
    // controller
    Controller,
    CalendarCtrl,
    DashboardGoalCtrl
) {

    var DashboardCtrl = Controller.extend({
        authDefault: true,
        routes: {
            '*dashboard': 'index',
        },

        subRoutes: {
            calendar: 'calendar/',
            goal: 'goal/'
        },

        initialize: function(prefix, opt) {
            opt = opt || {};

            this.role = opt.role;

            this.ctrl = {
                calendar: new CalendarCtrl(
                    this.getPrefix('calendar', { userId: ':userId', groupId: ':groupId' }), {
                        layout: this.layoutCtrl,
                        url: this.url.calendar,
                        role: this.role
                    }),
                goal: new DashboardGoalCtrl(
                    this.getPrefix('goal', { userId: ':userId', groupId: ':groupId' }), {
                        layout: this.layoutCtrl,
                        url: this.url.goal,
                        role: this.role
                    }),
            };

            this.listenTo(this.ctrl.calendar, 'before:route', this.onCalendarRoute);
            this.listenTo(this.ctrl.goal, 'before:route', this.onGoalRoute);
        },

        index: function(groupId, userId) {
            this.getLayout().getContent().toggleInfo(false);
            this.renderDashboard(groupId, userId);
        },

        renderDashboard: function(groupId, userId) {
            this.getLayout().showDashboard(groupId, userId);
        },

        ////////////
        // events //
        ////////////
        onBack: function() {
            Backbone.history.navigate(
                Mustache.render(this.url.root, {
                    userId: this.profile.id,
                    groupId: this.group.id
                }), { trigger: true });
        },

        onCalendarRoute: function(route, params) {
            this.renderDashboard.apply(this, params);
        },

        onGoalRoute: function(route, params) {
            this.renderDashboard.apply(this, params);
        },
    });

    return DashboardCtrl;
});

